import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';
import { RequestInterceptor } from './types';

/**
 *  Axios拦截器注册类
 */
class RequestInterceptors {
  /**
     * 注册使用拦截器
     * @param interceptor 拦截器实例
     * @returns
     */
  use(interceptor: RequestInterceptor) {
    const {
      handleRequest,
      handleRequestError,
      handleResponse,
      handleResponseError,
    } = interceptor;

    // 对请求拦截处理
    if (handleRequest || handleRequestError) {
      axios.interceptors.request.use((config: AxiosRequestConfig) => {
        if (handleRequest) {
          return handleRequest.call(interceptor, config);
        }
        return config;
      }, (error: AxiosError) => {
        if (handleRequestError) {
          return handleRequestError.call(interceptor, error);
        }
        return Promise.reject(error);
      });
    }

    // 对响应拦截处理
    if (handleResponse || handleResponseError) {
      axios.interceptors.response.use((response: AxiosResponse) => {
        if (handleResponse) {
          return handleResponse.call(interceptor, response);
        }
        return response;
      }, (error: AxiosError) => {
        if (handleResponseError) {
          return handleResponseError.call(interceptor, error);
        }
        return Promise.reject(error);
      });
    }
    return this;
  }
}

export default new RequestInterceptors();

